import SPBaseModule from '../../../../lib/SPBaseModule'
import Bestseller from '../SaleStat/Bestseller'
import styles from './BestsellerRanking.css'
import {
  GA_CLICK_ACTION,
  getI13nModel
} from './BestsellerRanking.ga'

class BestsellerRanking extends SPBaseModule {
  sendPageviewByAction = (action) => {
    const i13nModel = getI13nModel(action)
    this.props.sendDashboardPageview(i13nModel)
  }

  render () {
    const {
      sharedLink,
      fetchPaginationBestsellers
    } = this.props

    return (
      <div
        data-role='bestseller-ranking'
      >
        <Bestseller
          title=''
          rowLimit={5}
          sharedLink={sharedLink}
          className={styles.bestseller}
          fetchPaginationBestsellers={fetchPaginationBestsellers}
          gaAction={GA_CLICK_ACTION}
          sendDashboardPageview={this.sendPageviewByAction}
        />
      </div>
    )
  }
}

export default BestsellerRanking
